import { z } from 'zod';

export const Color = z
  .enum([
    'Aqua',
    'Violet',
    'Green',
    'Orange',
    'Yellow',
    'Raspberry',
    'Blue',
    'Gray',
    'LightGray',
    'Lime',
  ])
  .describe('Color');

export const Colors = Object.values(Color.Values);

export type Color = z.infer<typeof Color>;
